import React from "react";
import moment from "moment";
import "date-fns";

import { makeStyles } from "@material-ui/core/styles";

import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Typography from "@material-ui/core/Typography";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
// import { width } from "@material-ui/system";

const useStyles = makeStyles(theme => ({
  modal: {
    display: "inline",
    alignItems: "center",
    justifyContent: "center",
    width: 800,
    margin: "auto"
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}));

export default function DetailModal(props) {
  const classes = useStyles();
  const { openDetailModal, setDetailModal, data } = props;

  const handleClose = () => {
    setDetailModal(false);
  };

  return (
    <div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={openDetailModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500
        }}
      >
        <Fade in={openDetailModal}>
          <div className={classes.paper}>
            <ListItem divider>
              <ListItemText>
                <Typography
                  align="center"
                  variant="h4"
                  color="primary"
                  display="block"
                  className={classes.title}
                >
                  Details
                </Typography>
              </ListItemText>
            </ListItem>

            <ListItem color="primary" divider>
              <ListItemText
                primary="Subject: "
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="body2"
                      className={classes.inline}
                      color="textSecondary"
                    >
                      {data.title}
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
            <ListItem color="primary" divider>
              <ListItemText
                primary="Description: "
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="body2"
                      className={classes.inline}
                      color="textSecondary"
                    >
                      {data.body}
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
            <ListItem color="primary" divider>
              <ListItemText
                primary="Added: "
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="body2"
                      className={classes.inline}
                      color="textSecondary"
                    >
                      {moment(data.date).format("MMMM Do, YYYY")}
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
            <ListItem color="primary" divider>
              <ListItemText
                primary="Deadline: "
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="body2"
                      className={classes.inline}
                      color="textSecondary"
                    >
                      {moment(data.deadline).format("MMMM Do, YYYY")}
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </div>
        </Fade>
      </Modal>
    </div>
  );
}
